import { produce } from "immer";
import { AdminSliceCreator, AdminStoreState } from "./useAdminStore";

export interface StageStoreState {
   selectedStageId: number | null;
   setSelectedStageId: (id: number | null) => void;
   selectStage: (stageId: number) => void;
}

export const createStageSlice: AdminSliceCreator<StageStoreState> = (set) => ({
   selectedStageId: null,

   selectStage: (stageId) => {
      set(
         produce((state: AdminStoreState) => {
            state.selectedStageId = stageId;
            state.selectedOptionId = null;
            state.selectedItemId = null;
         })
      );
   },

   setSelectedStageId: (id) => {
      set(
         produce((state: AdminStoreState) => {
            state.selectedStageId = id;
         })
      );
   },
});
